import { forwardRef, memo } from 'react'
import styled, { css } from 'styled-components'

import InputBase from '../InputBase'
import SVGIcon from 'components/modules/common/SVGIcon/SVGIcon'

export default memo(
  forwardRef(function Input(
    { label, isError, disabled, errorMsg, width, isClearBtn, onClear, ...rest },
    ref,
  ) {
    return (
      <InputBase>
        {label && <InputLabel htmlFor={rest.id}>{label}</InputLabel>}
        <div>
          <InputStyle
            ref={ref}
            disabled={disabled}
            width={width}
            isClearBtn={isClearBtn}
            {...rest}
          />
          {isClearBtn ? (
            <ClearButton onClick={onClear}>
              <SVGIcon name="close" />
            </ClearButton>
          ) : null}
          {errorMsg && <ErrorMsg>{errorMsg}</ErrorMsg>}
        </div>
      </InputBase>
    )
  }),
)

const InputLabel = styled.label`
  font-size: calc(100vw * (14 / 375));
  font-weight: 500;
  line-height: calc(100vw * (20 / 375));
  margin-bottom: calc(100vw * (8 / 375));
  color: #4e4e4e;
`

const InputStyle = styled.input`
  border: 1px solid #d5d5d5;
  border-radius: calc(100vw * (5 / 375));
  padding: calc(100vw * (12 / 375)) calc(100vw * (8 / 375));
  font-size: calc(100vw * (14 / 375));
  font-weight: 400;
  line-height: calc(100vw * (20 / 375));
  outline: none;
  width: ${({ width }) => (width ? `calc(100vw * (${width} / 375))` : '100%')};

  &::placeholder {
    color: #c6c6c6;
  }

  &:focus {
    border: 1px solid #fbe7b2;
  }

  ${({ isClearBtn }) =>
    isClearBtn &&
    css`
      padding-right: calc(100vw * (40 / 375));
    `}
`

const ErrorMsg = styled.span`
  display: block;
  font-size: calc(100vw * (11 / 375));
  font-weight: 400;
  line-height: calc(100vw * (16 / 375));
  color: #de0000;
  margin-top: calc(100vw * (5 / 375));
`

const ClearButton = styled.button`
  position: absolute;
  bottom: 50%;
  right: calc(100vw * (11 / 375));
  transform: translateY(50%);
  width: calc(100vw * (18 / 375));
  height: calc(100vw * (18 / 375));
  border-radius: 50%;
  padding: calc(100vw * (6 / 375));
  background-color: #eaeaea;
`
